// Import form handler
import { initializeAppointmentFormHandler } from '../../../../components/email/service/appointmentFormHandler';

// Function to initialize appointment section (form validation, service select, etc.)
export function initializeAppointmentSection(
    container?: HTMLElement | null,
    form?: HTMLFormElement | null,
    serviceSelect?: HTMLSelectElement | null,
    services?: Array<{ value: string; key: string }>,
    servicesTranslations?: any,
    language?: string
) {
    const jQuery = (window as any).jQuery;
    if (typeof jQuery === 'undefined') {
        // Retry if jQuery not loaded yet
        setTimeout(() => initializeAppointmentSection(container, form, serviceSelect, services, servicesTranslations, language), 500);
        return;
    }

    try {
        // Populate service select
        if (serviceSelect && services && servicesTranslations) {
            const currentValue = serviceSelect.value;
            serviceSelect.innerHTML = '';

            // Add placeholder option
            const placeholder = document.createElement('option');
            placeholder.value = '';
            placeholder.selected = !currentValue;
            placeholder.textContent = language === 'pt' ? 'Selecionar Serviço' : 'Select Service';
            serviceSelect.appendChild(placeholder);

            // Add service options
            services.forEach(s => {
                const option = document.createElement('option');
                option.value = s.value;
                option.selected = currentValue === s.value;
                
                // Get translation - handle both proxy object and direct access
                let label = s.value; // fallback to value
                try {
                    const translationValue = servicesTranslations?.[s.key];
                    if (translationValue) {
                        // If it's already a string (from proxy), use it directly
                        if (typeof translationValue === 'string') {
                            label = translationValue;
                        } 
                        // If it's an object with language keys, access the language
                        else if (typeof translationValue === 'object' && translationValue !== null) {
                            label = translationValue[language || 'pt'] || translationValue['pt'] || translationValue['en'] || s.value;
                        }
                    }
                } catch (e) {
                    label = s.value;
                }
                
                option.textContent = label;
                serviceSelect.appendChild(option);
            });

            // Initialize nice-select if available
            const $select = jQuery(serviceSelect);
            const niceSelectWrapper = $select.next('.nice-select');
            
            if (niceSelectWrapper.length > 0) {
                $select.niceSelect('destroy');
            }
            
            setTimeout(() => {
                if (typeof jQuery.fn.niceSelect !== 'undefined') {
                    $select.niceSelect();
                }
            }, 50);
        }

        // Initialize form validation
        if (form && typeof jQuery.fn.validate !== 'undefined') {
            jQuery(form).validate({
                rules: {
                    email: {
                        required: true,
                        email: true
                    },
                    name: {
                        required: true
                    },
                    Phone: {
                        required: true
                    },
                    message: {
                        required: true
                    },
                    privacy_policy: {
                        required: true
                    }
                },
                messages: {
                    email: {
                        required: language === 'pt' ? 'Este campo é obrigatório.' : 'This field is required.',
                        email: language === 'pt' ? 'Por favor, insira um endereço de email válido.' : 'Please enter a valid email address.'
                    },
                    name: {
                        required: language === 'pt' ? 'Este campo é obrigatório.' : 'This field is required.'
                    },
                    Phone: {
                        required: language === 'pt' ? 'Este campo é obrigatório.' : 'This field is required.'
                    },
                    message: {
                        required: language === 'pt' ? 'Este campo é obrigatório.' : 'This field is required.'
                    },
                    privacy_policy: {
                        required: language === 'pt' ? 'Este campo é obrigatório.' : 'This field is required.'
                    }
                },
                submitHandler: function(_formElement: HTMLFormElement) {
                    // Form submission is handled by initializeAppointmentFormHandler
                    // This is just for validation
                }
            });
        }

        // Initialize form submission handler (after validation is set up)
        if (form) {
            setTimeout(() => {
                initializeAppointmentFormHandler(form, language || 'pt');
            }, 100);
        }

    } catch (error) {
    }
}

// Expose function globally for use in other scripts
if (typeof window !== 'undefined') {
    (window as any).initializeAppointmentSection = initializeAppointmentSection;
}

